import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink, useLocation } from 'react-router-dom';
import Logo from './partials/Logo';
import MkBtn from '../mk/MkBtn';
import { kmoPlayHref } from '../../marketing/links';
import { mkTrack } from '../../marketing/track';

const propTypes = {
  navPosition: PropTypes.string,
  hideNav: PropTypes.bool,
  hideSignin: PropTypes.bool,
  bottomOuterDivider: PropTypes.bool,
  bottomDivider: PropTypes.bool
};

const defaultProps = {
  navPosition: '',
  hideNav: false,
  hideSignin: false,
  bottomOuterDivider: false,
  bottomDivider: false
};

const Header = ({
  className,
  navPosition,
  hideNav,
  hideSignin,
  bottomOuterDivider,
  bottomDivider,
  ...props
}) => {
  const [isActive, setIsactive] = useState(false);
  const location = useLocation();
  const onBmbPage = location.pathname === '/bring-me-back';

  const nav = useRef(null);
  const hamburger = useRef(null);

  useEffect(() => {
    isActive && openMenu();
    document.addEventListener('keydown', keyPress);
    document.addEventListener('click', clickOutside);
    return () => {
      document.removeEventListener('keydown', keyPress);
      document.removeEventListener('click', clickOutside);
      closeMenu();
    };
  });

  const openMenu = () => {
    document.body.classList.add('off-nav-is-active');
    nav.current.style.maxHeight = nav.current.scrollHeight + 'px';
    setIsactive(true);
  };

  const closeMenu = () => {
    document.body.classList.remove('off-nav-is-active');
    nav.current && (nav.current.style.maxHeight = null);
    setIsactive(false);
  };

  const keyPress = (e) => {
    isActive && e.keyCode === 27 && closeMenu();
  };

  const clickOutside = (e) => {
    if (!nav.current) return;
    if (
      !isActive ||
      nav.current.contains(e.target) ||
      e.target === hamburger.current
    )
      return;
    closeMenu();
  };

  const navClass = ({ isActive: current }) => (current ? 'mk-nav-current' : undefined);

  const navClick = (item) => {
    closeMenu();
    mkTrack('nav_click', `${item}:header`);
  };

  const classes = classNames(
    'site-header',
    bottomOuterDivider && 'has-bottom-divider',
    className
  );

  return (
    <header {...props} className={classes}>
      <div className='container'>
        <div
          className={classNames(
            'site-header-inner',
            bottomDivider && 'has-bottom-divider'
          )}
        >
          <Logo />
          {!hideNav && (
            <>
              <button
                ref={hamburger}
                className='header-nav-toggle'
                aria-expanded={isActive}
                aria-controls='mk-primary-nav'
                onClick={isActive ? closeMenu : openMenu}
              >
                <span className='screen-reader'>Menu</span>
                <span className='hamburger'>
                  <span className='hamburger-inner'></span>
                </span>
              </button>
              <nav
                ref={nav}
                id='mk-primary-nav'
                aria-label='Main'
                className={classNames('header-nav', isActive && 'is-active')}
              >
                <div className='header-nav-inner'>
                  <ul
                    className={classNames(
                      'list-reset text-xxs',
                      navPosition && `header-nav-${navPosition}`
                    )}
                  >
                    <li>
                      <NavLink
                        to='/'
                        end
                        className={navClass}
                        onClick={() => navClick('kmo')}
                      >
                        Keep Me Out
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/bring-me-back'
                        className={navClass}
                        onClick={() => navClick('bmb')}
                      >
                        Bring Me Back
                        <span className='mk-pill mk-pill--new' aria-hidden='true'>
                          New
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/Help'
                        className={navClass}
                        onClick={() => navClick('help')}
                      >
                        Help
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to='/Privacy'
                        className={navClass}
                        onClick={() => navClick('privacy')}
                      >
                        Privacy
                      </NavLink>
                    </li>
                  </ul>
                  <ul className='list-reset header-nav-right mk-header-cta'>
                    <li>
                      {onBmbPage ? (
                        <MkBtn
                          variant='kmo'
                          size='sm'
                          href='#get'
                          onClick={() => {
                            closeMenu();
                            mkTrack('cta_click', 'bmb_anchor:header');
                          }}
                        >
                          Get Bring Me Back
                        </MkBtn>
                      ) : (
                        <MkBtn
                          variant='kmo'
                          size='sm'
                          href={kmoPlayHref('header')}
                          onClick={() => {
                            closeMenu();
                            mkTrack('store_click', 'kmo:play:header');
                          }}
                        >
                          Get Keep Me Out
                        </MkBtn>
                      )}
                    </li>
                  </ul>
                </div>
              </nav>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;

export default Header;
